(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivityWorkflowPipelineInput', rmsActivityWorkflowPipelineInputComponent);

    function rmsActivityWorkflowPipelineInputComponent() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                getModel: '=?',
                inputValidationErrorMessage: '=?'
            },
            templateUrl: 'common/app/components/activities/activity-input-panel/activity-workflow-pipeline-input',
            controller: rmsActivityWorkflowPipelineInputComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsActivityWorkflowPipelineInputComponentCtrl(ActivityInputService, lodash) {
        var vm = this;
        var inputOptions = {};
        this.$onInit = function() {
            vm.currentData = {};
            inputOptions = vm.options.inputOptions;

            lodash.set(inputOptions, 'onChangeInstructions', [
                {name: 'sel_email_from', type: 'setSignature'}
            ]);

            lodash.set(inputOptions, 'signatureSettings', {
                fieldName: 'txtbox_description'
            });

            init();
            vm.discard = discard;
        }

        function init() {
            vm.selectedActivityType = vm.options.activityTypes[0];
            vm.currentData = ActivityInputService.initInputOptions(
                vm.currentData,
                vm.selectedActivityType,
                inputOptions,
                lodash.get(vm.options, 'attachmentOptions', {})
            );
        }

        function discard() {
            vm.reset();
            vm.inputValidationErrorMessage = '';
        }
    }
})();